<template>
  <div class="dialog-container wt-dialog-container ">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
      <wt-form-table-list ref="goodsTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="garbageWeight" slot-scope="data">
          <span>{{ $wtUtil.transWeight(data.row.garbageWeight) }}</span>
        </template>
        <template slot="garbageImg" slot-scope="data">
          <wt-auth slot="error" class="search-form-btn">
            <el-button size="mini" type="primary" @click="toViewImg(data.row)">查看</el-button>
          </wt-auth>
        </template>
        <template slot="deliveryWay" slot-scope="data">
          <span>{{data.row.deliveryWay | FILTER_Delivery_State}}</span>
        </template>
       </wt-form-table-list>
    </wt-form-table>
    <image-viewer :z-index="999" :initial-index="0" v-if="showViewer" :on-close="closeViewer" :url-list="previewSrcList"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ImageViewer from '@/components/image-viewer/index.vue'
export default {
  name: 'SiteOtherDeliveryViewTab',
  isAutoComponent: true,
  components: { ImageViewer },
  props: ['siteId'],
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      detailFormButtons: {
        title: '投递记录',
        elements: [{ name: '取消', key: 'CLOSE', action: 'CLOSE' }]
      },
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULES_GOODS',
        formComponent: {
          list: { type: 'default', value: '/modules/site/siteDeliveryOtherList', params: { siteId: '' }}
        },
        formInputsData: [{ name: '投递时间', key: 'dataTimeRange', value: [], type: 'datetime' }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/site/siteDeliveryOtherListImport',
          fileName: '其他类型记录' }],
        formTableData: [
          { name: '用户昵称', key: 'nickName', type: 'text' },
          { name: '手机号', key: 'phone', type: 'text' },
          { name: '物品名称', key: 'garbageName', type: 'text' },
          { name: '投递总量(个)', key: 'garbageCount', type: 'text' },
          { name: '总积分（个）', key: 'garbageTotalPrice', type: 'text' },
          { name: '投递时间', key: 'createTime', type: 'text', sortable: 'custom' },
          { name: '操作人员', key: 'employeesUserName', type: 'text' },
          { name: '货物图片', key: 'garbageImg', type: 'custom' }],
        formTableButtonsData: [],
        formResult: { },
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonHidden: true }
      },
      showViewer: false,
      previewSrcList: []
    }
  },
  created() {
    this.form.formComponent.list.params.siteId = this.siteId
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    toViewImg(row) {
      if (row.garbageImg && row.garbageImg.length > 0) {
        if (row.garbageImg && row.garbageImg.length > 0) {
          const splitResult = row.garbageImg.split(',')
          for (const item of splitResult) {
            this.previewSrcList.push(this.imgUrl + item)
          }
          this.showViewer = true
        }
      } else {
        this.$message({ message: '未上传图片', type: 'warning' })
      }
    },
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      }
    },
    onButtonAction(data) {},
    closeViewer() {
      this.showViewer = false
    }
  }
}
</script>
